import styled from '@emotion/styled';

import theme from 'styles/theme';

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-shrink: 0;
`;

export const AccountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  flex-shrink: 0;
  overflow: visible;
  max-width: none;
`;

export const AvatarContainer = styled.div`
  height: 40px;
  width: 40px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    height: 35px;
    width: 35px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  & svg {
    font-size: 20px;
    color: #3d3d3d;
  }

  @media (max-width: 1100px) and (min-width: 769px) {
    & svg {
      color: #fff;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const UserName = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  color: ${theme.colors.blue};
  white-space: nowrap;
  flex-shrink: 0;
  overflow: visible;
  text-overflow: clip;
  max-width: none;
  display: inline-block;

  @media (max-width: 1100px) and (min-width: 769px) {
    color: #fff;
  }
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${theme.colors.gray};
`;

export const DropdownMenu = styled.div`
  width: 150px;
  z-index: 5;
  background: white;
  position: absolute;
  top: 60px;
  right: 0;
  border-radius: 5px;
  box-shadow: 0 0 8px #d8d8d8;
  display: flex;
  gap: 15px;
  padding: 12px;
  flex-direction: column;
`;

export const DropdownItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  & svg {
    font-size: 22px;
    color: ${theme.colors.blue};
  }
`;

export const DropdownText = styled.span`
  font-size: 12px;
  color: ${theme.colors.gray};
  margin-left: 7px;

  ${DropdownItem}:hover & {
    color: ${theme.colors.blue};
  }
`;
